const EmploymentTypeEnum = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL',
    STUDENT: 'STUDENT'
  };

export default EmploymentTypeEnum;